<template>
  <div class="page-content">
         <page-template
      ref="deposit"
      :tableOptions="storeReportTable"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    >
    </page-template>
  </div>
</template>

<script>
import api from "@/config/api";
import pageTemplate from "@/components/template/pageTemplate";
import userPower from "@/mixin/userPower";

export default {
   mixins: [userPower],
  components: { pageTemplate},
  data() {
    return {
      indexShow: false,
      searchOptions: {
        simple: [
          {label: '充值门店', prop: 'storeId', type: 'select',span:24,data:[] },
        ],
        complex: [
          {
            label: '来源',
            prop: 'sourceType',
            type: 'select', span: 12,
            data: this.$utils.getCacheStatus("mbDepositRecord.sourceType")
          },
          {
            label: "选择日期",
            prop: "CreateDttm",
            type: "datetimeRange",
            dateType: "datetime",
            span: 12,
          },
        ],
      },
      storeReportTable: {
        showSummary: true,
        summaryColumns: ['depositMoney', 'givingMoney'],
        indexShow: true, //是否显示索引
        columns: [
          {
            label: "充值门店",
            prop: "storeName",
            align: "center",
            width:"190"
          },
          {
            label: "收银员",
            prop: "cashierName",
            align: "center",
            width:"120"
          },
          {
            label: "会员手机号",
            prop: "memberPhone",
            align: "center",
            width:"190"
          },
          {
            label: "会员名称",
            prop: "memberName",
            align: "center",
             width:"120"
          },
          {
            label: "充值金额",
            prop: "depositMoney",
            align: "center",
             width:"120"
          },
          {
            label: "赠送金额",
            prop: "givingMoney",
            align: "center",
            width:"120"
          },
          {
            label: "来源",
            prop: "sourceType",
            align: "center",
            width:"120",
            enumData:this.$utils.getCacheStatus("mbDepositRecord.sourceType")
          },
          {
            label: "充值时间",
            prop: "createDttm",
            align: "center",
            width:"190"
          },
        ],
        url: api.report.memberDetail
      },
      toolConfig: [
        {
          label: "导出",
          code: "export",
          callback:this.exportData
        },
      ],
    };
  },
  created() {
     this.allStore()
     this.setStore(this.searchOptions.simple);
  },
  mounted() {
  },
  methods: {
    allStore(){
      let mes=[]
      mes.unshift({name:"所有门店",value:""});
      this.$axios.fetchPost(api.system.seStore+'/list').then(data=>{
        if(data.code===200){
          data.data.unshift({name:"所有门店",value:""});
           this.searchOptions.simple.filter(item=>item.prop==="storeId")[0].data=data.data;
        }
      })
    },
    exportData() {
      let params = this.$refs["deposit"].getCurrentParams();
      params.exportCode = 'memberRechargeExport';
      this.$axios.fetchPost(api.report.detailExport, params).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '导出异常', type: 'error'});
        }
      })
    }
  },
};
</script>

<style scoped>
.page-template .centerBack {
  background: #fff;
  border-radius: 8px;
  padding: 25px;
}
.page-template .echartsArea {
  height: 270px;
  margin-bottom: 12px;
}

</style>



// WEBPACK FOOTER //
// src/page/report/member/topUp/Detail.vue